export default __webpack_public_path__ + "static/media/background.f8f46b54.jpeg";